// extracted by mini-css-extract-plugin
export var footer = "style-module--footer--fed2a";
export var icon = "style-module--icon--e67c9";